export default __webpack_public_path__ + "static/media/boshna.ffa24887.png";